import { getFormattedDate } from '@app/utils/date'
import { dateFormat } from '@app/constants'

import type { TableData } from '@app/types/table'
import type { MonitoringRegistryDataSource } from '@app/pages/MonitoringRegistryPage/types'
import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringTaskDto } from '@app/api/routes/monitoringTasks/dtos'
import type { MonitoringTasksFilerData } from '@app/api/routes/monitoringTasks/types'
import type { DecodedValueMap } from 'use-query-params'
import type { QueryParamConfigMap } from 'serialize-query-params'

export const adaptMonitoringRegistryTableData = (
  monitoringTaskResponse: ResponseDto<MonitoringTaskDto>
): TableData<MonitoringRegistryDataSource> => {
  const { count, results: monitoringTask } = monitoringTaskResponse

  const dataSource: MonitoringRegistryDataSource[] = monitoringTask.map(dto => ({
    key: dto.id,
    monitoringId: dto.id,
    date: getFormattedDate(dto.monitoringStartAt, dateFormat.DD_MM_YYYY),
    monitoringType: dto.monitoringType?.name ?? null,
    promotionName: dto.promo?.promotionNumber ?? null,
    promoDateFrom: getFormattedDate(dto.promo?.dateFrom, dateFormat.DD_MM_YYYY),
    promoDateTo: getFormattedDate(dto.promo?.dateTo, dateFormat.DD_MM_YYYY),
    cluster: dto.cluster?.name ?? null,
    monitoringSubtype: dto.monitoringSubtype?.name ?? null,
    contractor: dto.contractor?.name ?? null,
    salesOrganization: dto.salesOrganization?.name ?? null,
    status: dto.status
  }))

  return { count, dataSource }
}

export const adaptMonitoringTasksFilerData = (
  queryParams: DecodedValueMap<QueryParamConfigMap>
): MonitoringTasksFilerData => {
  return {
    monitoringTypeIds: queryParams.monitoringTypeIds,
    storeIds: queryParams.storeIds,
    clusterIds: queryParams.clusterIds,
    salesOrganizationIds: queryParams.salesOrganizationIds,
    contractorIds: queryParams.contractorIds,
    status: queryParams.status,
    createdAtAfter: queryParams.createdAtAfter,
    createdAtBefore: queryParams.createdAtBefore,
    showStopped: queryParams.showStopped
  }
}
